<template>
  <div class="gyomuHokoku">
    <el-form ref="form" :model="form">
      <span id="formArea">
        <span id="leftButton">
          <span id="shainShimeiLabel">スタッフ氏名：</span>
          <span id="shainShimei">{{form.gyomuHokoku.shain.shainShimei}}</span>
          <span id="shainShimeiLabel">状況：</span>
          <span id="shainShimei">{{form.gyomuHokoku.jokyoKubunMei}}</span>
          <el-button id="teijiIkkatsu" size="mini" type="info" :disabled="!canEdit" @click="onTeijiIkkatsu">定時入力</el-button>
        </span>
        <span id="centerButton">
          <el-button type="default" @click="onChange(-1)" size="medium" icon="el-icon-arrow-left">前月</el-button>
          <el-date-picker v-model="form.nengetsu" type="month" @change="onChange" format="yyyy年 M月" value-format="yyyy-MM" :editable="false" :clearable="false" class="nengetsu" size="medium"></el-date-picker>
          <el-button type="default" @click="onChange(1)" size="medium">翌月 <i class="el-icon-arrow-right" /></el-button>
          <div style="display: inline-block">
            <el-upload 
              v-if="!isRomu"
              action="/gwr/upload/"
              multiple
              :limit="5"
              :on-exceed="handleExceed"
              :on-success="handleSuccess"
              :on-error="handleError"
              :file-list="fileList"
              :disabled="!canEdit"
              :show-file-list="false">
              <el-button id="syuhoTorikomi" type="info" size="mini" :disabled="!canEdit">週報取込</el-button>
            </el-upload>
            <el-button v-if="isRomu" id="yukyuZan" size="mini" type="info" @click="isYukyuDialogVisible = true">有休残</el-button>
          </div>
        </span>
        <span id="rightButton">
          <el-button type="danger" @click="onCheck('')" size="medium">Check</el-button>
          <el-button type="primary" @click="onCheck('download')" size="medium">Excel出力</el-button>
          <el-button v-if="canSendJocho" :disabled="isDisableSend" type="success" @click="onCheck('sendJocho')" size="medium">上長に提出</el-button>
          <el-button v-if="canSendRomu" :disabled="isDisableSend" type="success" @click="onCheck('sendRomu')" size="medium">労務に提出</el-button>
          <el-button v-if="canSendDairi" :disabled="isDisableSend" type="success" @click="onCheck('sendDairi')" size="medium">代理提出</el-button>
          <el-button v-if="canShonin" type="success" @click="onShonin()" size="medium">上長承認</el-button>
          <el-button v-if="canJochoSashimodoshi" type="warning" @click="onConfirm('jochoSashimodoshi')" size="medium">差戻し</el-button>
          <el-button v-if="canRomuSashimodoshi" type="warning" @click="onConfirm('romuSashimodoshi')" size="medium">差戻し</el-button>
          <el-button v-if="canRomuRenraku" type="warning" @click="onConfirm('romuRenraku')" size="medium">連絡</el-button>
          <el-button v-if="canKakutei" type="warning" @click="onKakutei()" size="medium">確定</el-button>
        </span>
        <span v-if="isRomu && !isMobile">
          <div id="romuCheck">
            <div>
              <el-button type="default" @click="onChangeUser(-1)" size="mini" icon="el-icon-arrow-left" style="margin-left: -15px !important;"></el-button>
              <el-button type="default" @click="onChangeUser(1)" size="mini" icon="el-icon-arrow-right" style="margin-right: 10px !important;"></el-button>
              <span>労務チェック</span>
              <span class="selecterLabel">１：</span>
              <el-switch v-model="form.gyomuHokoku.romuCheck1Flag" @change="saveRomuCheckFlag('1')"></el-switch>
            </div>
            <div>
              <span class="selecterLabel">２：</span>
              <el-switch v-model="form.gyomuHokoku.romuCheck2Flag" @change="saveRomuCheckFlag('2')"></el-switch>
            </div>
            <div>
              <span class="selecterLabel">３：</span>
              <el-switch v-model="form.gyomuHokoku.romuCheck3Flag" @change="saveRomuCheckFlag('3')"></el-switch>
            </div>
          </div>
          <div id="teiki" :style="form.gyomuHokoku.teikiHitsuyoFlag ? 'font-weight:bold;color:#2E7D32;background-color:#FCE4EC;' : ''">
            {{form.gyomuHokoku.teikiHitsuyoFlag ? "［定期支給］" : "［実費精算］"}}
          </div>
          <table id="keiroTable">
            <tr v-if="form.gyomuHokoku.tsukinKotsuhi1">
              <td>{{form.gyomuHokoku.kotsuKikanMei1}}</td>
              <td>{{form.gyomuHokoku.tsukinRoute1}}</td>
              <td style="text-align:right">{{form.gyomuHokoku.tsukinKotsuhi1}}</td>
            </tr>
            <tr v-if="form.gyomuHokoku.tsukinKotsuhi2">
              <td>{{form.gyomuHokoku.kotsuKikanMei2}}</td>
              <td>{{form.gyomuHokoku.tsukinRoute2}}</td>
              <td style="text-align:right">{{form.gyomuHokoku.tsukinKotsuhi2}}</td>
            </tr>
            <tr v-if="form.gyomuHokoku.tsukinKotsuhi3">
              <td>{{form.gyomuHokoku.kotsuKikanMei3}}</td>
              <td>{{form.gyomuHokoku.tsukinRoute3}}</td>
              <td style="text-align:right">{{form.gyomuHokoku.tsukinKotsuhi3}}</td>
            </tr>
            <tr v-if="form.gyomuHokoku.tsukinKotsuhi4">
              <td>{{form.gyomuHokoku.kotsuKikanMei4}}</td>
              <td>{{form.gyomuHokoku.tsukinRoute4}}</td>
              <td style="text-align:right">{{form.gyomuHokoku.tsukinKotsuhi4}}</td>
            </tr>
            <tr v-if="form.gyomuHokoku.tsukinKotsuhi5">
              <td>{{form.gyomuHokoku.kotsuKikanMei5}}</td>
              <td>{{form.gyomuHokoku.tsukinRoute5}}</td>
              <td style="text-align:right">{{form.gyomuHokoku.tsukinKotsuhi5}}</td>
            </tr>
            <tr>
              <td colspan="2">計</td>
              <td style="text-align:right">{{form.gyomuHokoku.tsukinKotsuhiGokei}}</td>
            </tr>
          </table>
        </span>
      </span>
    </el-form>
    <el-table id="gyomuHokokuTable" :class="tableSizeClass" :data="form.gyomuHokoku.kimmuJissekiList" :row-class-name="rowClassName" :summary-method="getSummaries" show-summary :height="tableHeight" v-loading="loading">
      <el-table-column label="編集" width="35">
        <template slot-scope="scope">
          <el-button icon="el-icon-edit" size="mini" :disabled="!canEdit" @click="onEdit(scope.row)"></el-button>
        </template>
      </el-table-column>
      <el-table-column label="コピ" width="35">
        <template slot-scope="scope">
          <el-button icon="el-icon-copy-document" size="mini" @click="onCopy(scope.row)"></el-button>
        </template>
      </el-table-column>
      <el-table-column label="ペ" width="35">
        <template slot-scope="scope">
          <el-button icon="el-icon-brush" size="mini" :disabled="!canEdit" @click="onPaste(scope.row)"></el-button>
        </template>
      </el-table-column>
      <el-table-column prop="kimmuBiDisplay" label="勤務日" width="85">
        <template slot-scope="scope">
          <span v-if="scope.row.yobi != '日' || scope.row.shuZangyo == null">{{scope.row.kimmuBiDisplay}}</span>
          <el-tooltip v-if="scope.row.yobi == '日' && scope.row.shuZangyo != null" effect="light" placement="right">
            <div slot="content" class="kimmuBi-tooltip">週間残業（月～日） {{scope.row.shuZangyo}}</div>
            <el-link type="success">{{scope.row.kimmuBiDisplay}}</el-link>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="yobi" label="曜" width="30"></el-table-column>
      <el-table-column label="始業時刻" width="60">
        <template slot-scope="scope">
          <span :class="cellClass(scope.row, 'shigyoJikoku')">{{ cellData(scope.row, 'shigyoJikoku') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="終了時刻" width="60">
        <template slot-scope="scope">
          <span :class="cellClass(scope.row, 'shugyoJikokuHyoji')">{{ cellData(scope.row, 'shugyoJikokuHyoji') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="昼食時間" width="60">
        <template slot-scope="scope">
          <span :class="cellClass(scope.row, 'chushokuJikan')">{{ cellData(scope.row, 'chushokuJikan') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="休憩時間" width="60">
        <template slot-scope="scope">
          <span :class="cellClass(scope.row, 'kyukeiJikan')">{{ cellData(scope.row, 'kyukeiJikan') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="時間外移動時間" width="60">
        <template slot-scope="scope">
          <span :class="cellClass(scope.row, 'jikanGaiIdoJikan')">{{ cellData(scope.row, 'jikanGaiIdoJikan') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="実働時間数">
        <el-table-column label="基準内" width="60">
          <template slot-scope="scope">
            <span :class="cellClass(scope.row, 'kijunJikanNaiKimmu')">{{ cellData(scope.row, 'kijunJikanNaiKimmu') }}</span>
          </template>
        </el-table-column>
        <el-table-column label="通常残業" width="60">
          <template slot-scope="scope">
            <span :class="cellClass(scope.row, 'tsujoZangyo')">{{ cellData(scope.row, 'tsujoZangyo') }}</span>
          </template>
        </el-table-column>
        <el-table-column label="土・祝日" width="60">
          <template slot-scope="scope">
            <span :class="cellClass(scope.row, 'doyoShukujitsuKimmu')">{{ cellData(scope.row, 'doyoShukujitsuKimmu') }}</span>
          </template>
        </el-table-column>
        <el-table-column label="日曜日" width="60">
          <template slot-scope="scope">
            <span :class="cellClass(scope.row, 'nichiyoKimmu')">{{ cellData(scope.row, 'nichiyoKimmu') }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="深夜勤務" width="60">
        <template slot-scope="scope">
          <span :class="cellClass(scope.row, 'shinyaKimmu')">{{ cellData(scope.row, 'shinyaKimmu') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="基準時間未満" width="60">
        <template slot-scope="scope">
          <span :class="cellClass(scope.row, 'kijunJikanMiman')">{{ cellData(scope.row, 'kijunJikanMiman') }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="tsukinTeate" label="通勤手当" width="60"></el-table-column>
      <el-table-column prop="kotsuhi" label="ルート外交通費" width="60"></el-table-column>
      <el-table-column prop="remoteFlag" label="ﾘﾓｰﾄ" width="30"></el-table-column>
      <el-table-column prop="biko" label="備考" class-name="biko"></el-table-column>
      <el-table-column label="残業理由" width="30">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.zangyoRiyu != null" effect="light" placement="left">
            <div slot="content" class="zangyoRiyu-tooltip">{{scope.row.zangyoRiyu}}</div>
            <el-link type="success">有</el-link>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="wfId" label="ワークフロー" width="180">
        <template slot-scope="scope">
          <a v-for="(wfId, index) in scope.row.wfIdList" :key="wfId" target="_wf"
            :href="'https://portal.genech.co.jp/cgi-bin/dneo/zflow.cgi?cmd=flowindex&log=on#cmd=flowdisp&id=' + wfId">
            {{scope.row.wfSubjectList[index]}}
          </a>
        </template>
      </el-table-column>
      <el-table-column v-if="isRomu" prop="kintai" label="勤怠記録" width="390">
        <template slot-scope="scope">
          <div v-for="(kintai, index) in scope.row.kintaiKirokuList" :key="kintai">
            <div style="text-align:left;">{{scope.row.kintaiKirokuList[index]}}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="isRomu" label="修正" width="35">
        <template slot-scope="scope">
          <el-button icon="el-icon-finished" size="mini" @click="onShusei(scope.row)"></el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog id="commentDialog" :title="commentDialogTitle" :visible.sync="isCommentDialogVisible" :width="isMobile ? '390px' : '600px'" :top="isMobile ? '10px' : '10vh'">
      <div v-if="showTeishutsuComment">
        <h3>コメントがある場合は以下に記入してください。</h3>
        <h4>※提出後はその月の業務報告書は編集できなくなります。</h4>
        <h4>変更が必要な場合は、一度差し戻してもらってください。</h4>
        <el-input type="textarea" rows="14" maxlength="500" show-word-limit v-model="form.gyomuHokoku.teishutsuComment"></el-input>
        <el-button type="primary" @click="onSend(target)" size="medium">提出</el-button>
        <el-button type="danger" @click="closeCommentDialog" size="medium">Cancel</el-button>
      </div>
      <div v-if="showJochoComment">
        <h3>コメントがある場合は以下に記入してください。</h3>
        <el-input type="textarea" rows="14" maxlength="500" show-word-limit v-model="form.gyomuHokoku.jochoComment"></el-input>
        <el-button type="primary" @click="onSend('jochoSashimodoshi')" size="medium">差戻し</el-button>
        <el-button type="danger" @click="closeCommentDialog" size="medium">Cancel</el-button>
      </div>
      <div v-if="showRomuComment">
        <h3>コメントがある場合は以下に記入してください。</h3>
        <el-input type="textarea" rows="14" maxlength="500" show-word-limit v-model="form.gyomuHokoku.romuComment"></el-input>
        <el-button type="primary" @click="onSend('romuSashimodoshi')" size="medium">差戻し</el-button>
        <el-button type="danger" @click="closeCommentDialog" size="medium">Cancel</el-button>
      </div>
      <div v-if="showRomuRenraku">
        <h3>スタッフ本人にメッセージを送信します。</h3>
        <el-input type="textarea" rows="14" maxlength="500" show-word-limit v-model="form.gyomuHokoku.romuComment"></el-input>
        <el-button type="primary" @click="onSend('romuRenraku')" size="medium">送信</el-button>
        <el-button type="danger" @click="closeCommentDialog" size="medium">Cancel</el-button>
      </div>
    </el-dialog>

    <el-dialog id="checkDialog" title="Check結果" :visible.sync="isCheckDialogVisible" :width="isMobile ? '390px' : '800px'" :top="isMobile ? '10px' : '10vh'">
      <div v-if="isConfirmDownload">
        <h3>以下の Error または Warning がありますが、Excel出力しますか？</h3>
        <el-button type="primary" @click="onDownload" size="medium">OK</el-button>
        <el-button type="danger" @click="closeCheckDialog" size="medium">Cancel</el-button>
      </div>
      <div v-if="isConfirmSendJocho">
        <h3>以下の Error または Warning がありますが、提出しますか？</h3>
        <el-button type="primary" @click="onConfirm('sendJocho')" size="medium">OK</el-button>
        <el-button type="danger" @click="closeCheckDialog" size="medium">Cancel</el-button>
      </div>
      <div v-if="isConfirmSendRomu">
        <h3>以下の Error または Warning がありますが、提出しますか？</h3>
        <el-button type="primary" @click="onConfirm('sendRomu')" size="medium">OK</el-button>
        <el-button type="danger" @click="closeCheckDialog" size="medium">Cancel</el-button>
      </div>
      <div v-if="isConfirmSendDairi">
        <h3>以下の Error または Warning がありますが、提出しますか？</h3>
        <el-button type="primary" @click="onConfirm('sendDairi')" size="medium">OK</el-button>
        <el-button type="danger" @click="closeCheckDialog" size="medium">Cancel</el-button>
      </div>
      <div v-if="isOk">
        <h1>OK!</h1>
      </div>
      <el-table id="errorListTable" :data="errorList" v-if="isError">
        <el-table-column prop="hiduke" label="日付" width="95"></el-table-column>
        <el-table-column prop="yobi" label="曜日" width="50"></el-table-column>
        <el-table-column prop="error" label="error!">
          <template #default="scope">
            <span v-html="scope.row.error"></span>
          </template>
        </el-table-column>
      </el-table>
      <el-table id="checkListTable" :data="checkList" v-if="isWarning">
        <el-table-column prop="hiduke" label="日付" width="95"></el-table-column>
        <el-table-column prop="yobi" label="曜日" width="50"></el-table-column>
        <el-table-column prop="warn" label="warning!">
          <template #default="scope">
            <span v-html="scope.row.warn"></span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog id="yukyuDialog" title="有給休暇" :visible.sync="isYukyuDialogVisible" width="200px" top="10vh">
      <div>{{yukyuJiten}} 時点の有休残</div>
      <table id="yukyuTable">
          <tr>
            <td>残日数</td>
            <td>{{yukyuZanNissu}}</td>
          </tr>
          <tr>
            <td>残時間数</td>
            <td>{{yukyuZanJikansu}}</td>
          </tr>
      </table>
    </el-dialog>

    <KimmuShusei :isShuseiDialogVisible.sync="isShuseiDialogVisible" :shuseiShainId.sync="shuseiShainId" :shuseiNengetsu.sync="shuseiNengetsu"
        :shuseiRow.sync="shuseiRow" :isK.sync="isK" @close-shusei-dialog="onCloseShuseiDialog" />
  </div>
</template>

<script>
import { notifySuccess, notifyWarning, notifyError, downloadFile } from '../utils.js'
import KimmuShusei from '../components/KimmuShusei.vue'

export default {
  name: 'GyomuHokoku',
  components: {
    KimmuShusei,
  },
  data() {
    return {
      form: {
        nengetsu: null,
        shainId: null,
        comment: null,
        gyomuHokoku: {
          shain: {
            shainShimei: ''
          },
          teishutsuComment: '',
          jochoComment: '',
          romuComment: '',
        },
        userList: [],
      },
      tableHeight: 600,
      copyKimmubi: '',
      loading: true,
      checkList: [],
      errorList: [],
      onedayOhiruGohanTime: "",
      onedayKyukeiTime: "",
      onedayKijyunJikanNaiTime: [0, 0],
      onedayTsujyoZangyoTime: [0, 0],
      onedayDoyoShukujitsuTime: [0, 0],
      onedayNichiyoTime: [0, 0],
      shuseiShainId: '',
      shuseiNengetsu: '',
      shuseiRow: {},
      isK: false,
      isWarning: false,
      isError: false,
      isOk: false,
      isConfirmDownload: false,
      isConfirmSendJocho: false,
      isConfirmSendRomu: false,
      isConfirmSendDairi: false,
      isCheckDialogVisible: false,
      isCommentDialogVisible: false,
      isShuseiDialogVisible: false,
      isYukyuDialogVisible: false,
      fileList: [],
      target: ""
    }
  },
  computed: {
    canEdit() {
      let kengenKubun = this.$parent.getKengenKubun();
      let jokyoKubun = this.form.gyomuHokoku.jokyoKubun;
      return ((this.form.gyomuHokoku.shainId == this.$parent.getShainId() && (jokyoKubun == '11' || jokyoKubun == '12'))
        || (this.form.gyomuHokoku.shainId != this.$parent.getShainId() && kengenKubun >= '700' && (jokyoKubun == '51' || jokyoKubun == '52')));
    },
    canSendJocho() {
      let loginUserId = this.$parent.getShainId();
      let jochoIds = this.$parent.getJochoIds();
      let jokyoKubun = this.form.gyomuHokoku.jokyoKubun;
      return (this.form.gyomuHokoku.shainId == loginUserId && (jokyoKubun == '11' || jokyoKubun == '12') && jochoIds.length > 0);
    },
    canSendRomu() {
      let loginUserId = this.$parent.getShainId();
      let jochoIds = this.$parent.getJochoIds();
      let jokyoKubun = this.form.gyomuHokoku.jokyoKubun;
      return (this.form.gyomuHokoku.shainId == loginUserId && (jokyoKubun == '11' || jokyoKubun == '12') && jochoIds.length == 0);
    },
    canSendDairi() {
      let kengenKubun = this.$parent.getKengenKubun();
      let loginUserId = this.$parent.getShainId();
      let jokyoKubun = this.form.gyomuHokoku.jokyoKubun;
      return (this.form.gyomuHokoku.shainId != loginUserId && kengenKubun >= '700' && (jokyoKubun == '11' || jokyoKubun == '12'));
    },
    canShonin() {
      let loginUserId = this.$parent.getShainId();
      let jokyoKubun = this.form.gyomuHokoku.jokyoKubun;
      let sendUser = this.form.gyomuHokoku.shain;
      return (jokyoKubun == '21' && (sendUser.jochoShainId == loginUserId || sendUser.jochoShainId2 == loginUserId || sendUser.jochoShainId3 == loginUserId));
    },
    canJochoSashimodoshi() {
      let loginUserId = this.$parent.getShainId();
      let jokyoKubun = this.form.gyomuHokoku.jokyoKubun;
      let sendUser = this.form.gyomuHokoku.shain;
      return (jokyoKubun == '21' && (sendUser.jochoShainId == loginUserId || sendUser.jochoShainId2 == loginUserId || sendUser.jochoShainId3 == loginUserId));
    },
    canRomuSashimodoshi() {
      let kengenKubun = this.$parent.getKengenKubun();
      let jokyoKubun = this.form.gyomuHokoku.jokyoKubun;
      return ((jokyoKubun == '51' || jokyoKubun == '52') && kengenKubun >= '700');
    },
    canRomuRenraku() {
      let kengenKubun = this.$parent.getKengenKubun();
      let jokyoKubun = this.form.gyomuHokoku.jokyoKubun;
      return ((jokyoKubun == '51' || jokyoKubun == '52' || jokyoKubun == '53' || jokyoKubun == '54') && kengenKubun >= '700');
    },
    canKakutei() {
      let kengenKubun = this.$parent.getKengenKubun();
      let jokyoKubun = this.form.gyomuHokoku.jokyoKubun;
      return (jokyoKubun == '52' && kengenKubun >= '700');
    },
    isMobile() {
      return this.$parent.isMobile;
    },
    isRomu() {
      let kengenKubun = this.$parent.getKengenKubun();
      return (kengenKubun >= '700');
    },
    tableSizeClass() {
      return this.isRomu ? "gyomuHokokuTableSizeRomu" : "gyomuHokokuTableSize";
    },
    isPirot() {
      let kengenKubun = this.$parent.getKengenKubun();
      return (kengenKubun >= '700' || kengenKubun == '200');
    },
    isDisableSend() {
      return (this.form.gyomuHokoku.nyuryokuNissu == 0);
    },
    showTeishutsuComment() {
      return (this.target == 'sendJocho' || this.target == 'sendRomu' || this.target == 'sendDairi');
    },
    showJochoComment() {
      return (this.target == 'jochoSashimodoshi');
    },
    showRomuComment() {
      return (this.target == 'romuSashimodoshi');
    },
    showRomuRenraku() {
      return (this.target == 'romuRenraku');
    },
    commentDialogTitle() {
      if (this.target == 'sendJocho' || this.target == 'sendRomu') {
        return '業務報告書 提出';
      } else if (this.target == 'sendDairi') {
        return '業務報告書 代理提出';
      } else if (this.target == 'jochoSashimodoshi' || this.target == 'romuSashimodoshi') {
        return '業務報告書 差戻し';
      } else if (this.target == 'romuRenraku') {
        return '労務からの連絡';
      }
      return '';
    },
    yukyuJiten() {
      return this.form.gyomuHokoku.kimmuJissekiList?.[0]?.kimmuBi.substring(0, 8) + '20';
    },
    yukyuZanNissu() {
      return this.form.gyomuHokoku.yukyuKyuka ? this.form.gyomuHokoku.yukyuKyuka.zanNissu : '未集計';
    },
    yukyuZanJikansu() {
      return this.form.gyomuHokoku.yukyuKyuka ? this.form.gyomuHokoku.yukyuKyuka.zanJikansu : '未集計';
    },
  },
  created() {
    if (this.$route.params.nengetsu === undefined) {
      this.form.nengetsu = this.$parent.getNengetsu();
    } else {
      this.form.nengetsu = this.$route.params.nengetsu;
    }
    if (this.$route.params.shainId === undefined) {
      this.form.shainId = null;
    } else {
      this.form.shainId = this.$route.params.shainId;
    }
    this.getData();
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      //this.tableHeight = window.innerHeight - 150;
      this.tableHeight = document.documentElement.clientHeight - (this.isMobile ? 240 : 150);
    },
    cellClass(row, prop) {
      return row.shusei?.[prop] ? 'shusei' : '';
    },
    cellData(row, prop) {
      return row.shusei?.[prop] ? row.shusei[prop] : row[prop];
    },
    getData() {
      this.loading = true;
      let url = '/gwr/gyomu/gyomuHokoku/' + this.form.nengetsu;
      if (this.form.shainId != null) {
        url += '/' + this.form.shainId;
      }
      this.$axios.get(url)
        .then((response) => {
          // リモートフラグ置き換え 
          response.data.kimmuJissekiList.forEach(jisseki => {
            jisseki.remoteFlag = jisseki.remoteFlag ? "ﾘﾓｰﾄ" : "";
            jisseki.tsukinTeate = jisseki.tsukinTeate?.toLocaleString();
            jisseki.kotsuhi = jisseki.kotsuhi?.toLocaleString();
          });
          this.form.gyomuHokoku = response.data;
          let gokei = 0;
          if (this.form.gyomuHokoku.tsukinKotsuhi1) {
            gokei += this.form.gyomuHokoku.tsukinKotsuhi1;
            this.form.gyomuHokoku.tsukinKotsuhi1 = this.form.gyomuHokoku.tsukinKotsuhi1.toLocaleString();
          }
          if (this.form.gyomuHokoku.tsukinKotsuhi2) {
            gokei += this.form.gyomuHokoku.tsukinKotsuhi2;
            this.form.gyomuHokoku.tsukinKotsuhi2 = this.form.gyomuHokoku.tsukinKotsuhi2.toLocaleString();
          }
          if (this.form.gyomuHokoku.tsukinKotsuhi3) {
            gokei += this.form.gyomuHokoku.tsukinKotsuhi3;
            this.form.gyomuHokoku.tsukinKotsuhi3 = this.form.gyomuHokoku.tsukinKotsuhi3.toLocaleString();
          }
          if (this.form.gyomuHokoku.tsukinKotsuhi4) {
            gokei += this.form.gyomuHokoku.tsukinKotsuhi4;
            this.form.gyomuHokoku.tsukinKotsuhi4 = this.form.gyomuHokoku.tsukinKotsuhi4.toLocaleString();
          }
          if (this.form.gyomuHokoku.tsukinKotsuhi5) {
            gokei += this.form.gyomuHokoku.tsukinKotsuhi5;
            this.form.gyomuHokoku.tsukinKotsuhi5 = this.form.gyomuHokoku.tsukinKotsuhi5.toLocaleString();
          }
          this.form.gyomuHokoku.tsukinKotsuhiGokei = gokei.toLocaleString();
          this.loading = false;
          this.handleResize();
        })
        .catch((error) => {
          notifyError(this, error, 'データ取得エラー');
        });
    },
    rowClassName({ row }) {
      if (row.yobi == '日' || row.yobi == '祝') {
        return 'sunday-row';
      } else if (row.yobi == '土') {
        return 'saturday-row';
      }
      return '';
    },
    getSummaries() {
      const sums = [];
      sums[9] = '合計';
      sums[10] = this.form.gyomuHokoku.gokeiKijunJikanNaiKimmu;
      sums[11] = this.form.gyomuHokoku.gokeiTsujoZangyo;
      sums[12] = this.form.gyomuHokoku.gokeiDoyoShukujitsuKimmu;
      sums[13] = this.form.gyomuHokoku.gokeiNichiyoKimmu;
      sums[14] = this.form.gyomuHokoku.gokeiShinyaKimmu;
      sums[15] = this.form.gyomuHokoku.gokeiKijunJikanMiman;
      sums[16] = this.form.gyomuHokoku.gokeiTsukinTeate?.toLocaleString();
      sums[17] = this.form.gyomuHokoku.gokeiKotsuhi?.toLocaleString();
      sums[18] = this.form.gyomuHokoku.gokeiRemoteNissu;
      if (this.parseNum("35:00") <= this.parseNum(this.form.gyomuHokoku.gokei36KyoteiCount)) {
        // 36法定超(法定休含)、年6回の回数
        sums[19] = '36法定超(法定休含) ' + this.form.gyomuHokoku.gokei36KyoteiCount + " (年:"+ this.form.gyomuHokoku.gokei36KyoteiNenCount + "回)";
      }
      sums[21] = ' 実働時間合計：' + this.form.gyomuHokoku.gokeiJitsudoJikan;
      if (this.isRomu) {
        let s = '出勤:' + this.form.gyomuHokoku.shukkinNissu;
        s += '、欠勤:' + this.form.gyomuHokoku.kekkinNissu;
        s += '、有休:' + this.form.gyomuHokoku.yukyuNissu + 'd ' + this.form.gyomuHokoku.yukyuJikansu + 'h';
        s += '、週40超:' + this.form.gyomuHokoku.shu40ChoJikan;
        s += '、月60超:' + this.form.gyomuHokoku.tsuki60ChoJikan;
        sums[22] = s;
      }
      return sums;
    },
    onChange(offset) {
      if (offset !== undefined) {
        this.form.nengetsu = this.$moment(this.form.nengetsu).add(offset, 'M').format('YYYY-MM');
      }
      this.$parent.setNengetsu(this.form.nengetsu);
      this.form.userList = [];
      this.getData();
    },
    async onChangeUser(offset) {
      if (!this.form.shainId) return;
      if (this.form.userList.length == 0) {
        await this.$axios.get('/gwr/gyomu/userList/' + this.form.nengetsu)
          .then((response) => {
            this.form.userList = response.data;
          })
          .catch((error) => {
            notifyError(this, error, 'データ取得エラー');
          });
      }
      let id = this.form.shainId;
      let kubun = this.form.gyomuHokoku.shain.shainKubun;
      let index = this.form.userList.indexOf(id + ':' + kubun);
      index += offset;
      if (index >= 0 && index < this.form.userList.length) {
        const idKubun = this.form.userList[index].split(':');
        id = idKubun[0];
        kubun = idKubun[1];
        if (kubun == '1') {
          this.$parent.switchMenu('GyomuHokoku', '/gyomu', { nengetsu: this.form.nengetsu, shainId: id });
          this.form.shainId = id;
          this.getData();
        } else if (kubun == '3' || kubun == '4' || kubun == '5' || kubun == '6') {
          this.$parent.switchMenu('GyomuHokokuK', '/gyomuK', { nengetsu: this.form.nengetsu, shainId: id });
        } else {
          notifyError(this, null, '予期せぬエラー', '社員区分の値が無効です。');
        }
      }
    },
    onEdit(row) {
      let param = { nengetsu: this.form.nengetsu, kimmuBi: row.kimmuBi };
      if (this.form.gyomuHokoku.shainId != this.$parent.getShainId()) {
        param.shainId = this.form.gyomuHokoku.shainId;
      }
      if (this.$parent.isSeishain) {
        this.$parent.switchMenu('KimmuJisseki', '/kimmu', param);
      } else {
        this.$parent.switchMenu('KimmuJissekiK', '/kimmuK', param);
      }
    },
    onCopy(row) {
      this.copyKimmubi = row.kimmuBi;
    },
    onPaste(row) {
      if (this.copyKimmubi != '') {
        let shainId = this.form.shainId;
        if (shainId == null) {
          shainId = this.$parent.getShainId();
        }
        this.$axios.get('/gwr/gyomu/copyKimmuJisseki/' + this.copyKimmubi + '/' + row.kimmuBi + '/' + shainId)
          .then((response) => {
            if (response.data != '') {
              // リモートフラグ置き換え 
              response.data.kimmuJissekiList.forEach(jisseki => {
                jisseki.remoteFlag = jisseki.remoteFlag ? "ﾘﾓｰﾄ" : "";
                jisseki.tsukinTeate = jisseki.tsukinTeate?.toLocaleString();
                jisseki.kotsuhi = jisseki.kotsuhi?.toLocaleString();
              });
              this.form.gyomuHokoku = response.data;
            }
          })
          .catch((error) => {
            notifyError(this, error, 'データ取得エラー');
          });
      }
    },
    saveRomuCheckFlag(no) {
      let params = {};
      params['shainId'] = this.form.gyomuHokoku.shainId;
      params['nengetsu'] = this.form.gyomuHokoku.nengetsu;
      params[`romuCheck${no}Flag`] = this.form.gyomuHokoku[`romuCheck${no}Flag`];
      params = new URLSearchParams(params);
      this.$axios.post(`/gwr/gyomu/saveRomuCheck${no}Flag`, params)
          .then(() => {
            notifySuccess(this, `労務チェック${no}を更新しました。`);
          })
          .catch((error) => {
            notifyError(this, error, 'データ登録エラー');
          });
    },
    onShusei(row) {
      this.shuseiShainId = this.form.gyomuHokoku.shainId;
      this.shuseiNengetsu = this.form.nengetsu;
      this.shuseiRow = row;
      this.isShuseiDialogVisible = true;
    },
    onCloseShuseiDialog(isUpdate) {
      this.isShuseiDialogVisible = false;
      if (isUpdate) {
        this.getData();
      }
    },
    onTeijiIkkatsu() {
      this.$confirm('未入力の日に、定時で一括入力します。<br/>よろしいですか？<br/>(社員設定ページで、リモートの既定値を設定可能。)', '確認', {
        confirmButtonText: 'はい',
        cancelButtonText: 'キャンセル',
        type: 'info',
        dangerouslyUseHTMLString: true
      }).then(() => {
        this.loading = true;
        this.$axios.get('/gwr/gyomu/teijiIkkatsu/' + this.form.nengetsu)
          .then((response) => {
            if (response.data != '') {
              // リモートフラグ置き換え 
              response.data.kimmuJissekiList.forEach(jisseki => {
                jisseki.remoteFlag = jisseki.remoteFlag ? "ﾘﾓｰﾄ" : "";
                jisseki.tsukinTeate = jisseki.tsukinTeate?.toLocaleString();
                jisseki.kotsuhi = jisseki.kotsuhi?.toLocaleString();
              });
              this.form.gyomuHokoku = response.data;
            }
            this.loading = false;
          })
          .catch((error) => {
            notifyError(this, error, 'データ登録エラー');
          });
      });
    },
    onConfirm(target) {
      this.target = target;
      this.isCommentDialogVisible = true;
      this.isCheckDialogVisible = false;
    },
    onShonin() {
      this.$confirm(this.form.gyomuHokoku.shain.shainShimei + 'さんの業務報告書を承認します。よろしいですか？', '確認', {
        confirmButtonText: 'はい',
        cancelButtonText: 'キャンセル',
        type: 'info'
      }).then(() => {
        this.onSend('shonin');
      });
    },
    onKakutei() {
      this.$confirm('業務報告書を確定します。よろしいですか？', '確認', {
        confirmButtonText: 'はい',
        cancelButtonText: 'キャンセル',
        type: 'info'
      }).then(() => {
        this.onSend('romuKakutei');
      });
    },
    onDownload() {
      this.isCheckDialogVisible = false;
      this.loading = true;
      this.$axios.get('/gwr/gyomu/download/' + this.form.nengetsu + '/' + this.form.gyomuHokoku.shainId, { responseType: 'blob' })
        .then((response) => {
          downloadFile(this, response);
        })
        .catch((error) => {
          notifyError(this, error, 'データ登録エラー');
        });
    },
    onSend(target) {
      this.loading = true;
      this.target = target;
      let shori = '';
      if (target == 'sendJocho' || target == 'sendRomu') {
        shori = '提出';
      } else if (target == 'sendDairi') {
        shori = '代理提出';
      } else if (target == 'shonin') {
        shori = '承認';
      } else if (target == 'jochoSashimodoshi' || target == 'romuSashimodoshi') {
        shori = '差戻';
      } else if (target == 'romuRenraku') {
        shori = '連絡';
      } else if (target == 'romuKakutei') {
        shori = '確定';
      }
      let params = {
        shainId: this.form.gyomuHokoku.shainId,
        nengetsu: this.form.gyomuHokoku.nengetsu,
        teishutsuComment: this.form.gyomuHokoku.teishutsuComment != null ? this.form.gyomuHokoku.teishutsuComment : '',
        jochoComment: this.form.gyomuHokoku.jochoComment != null ? this.form.gyomuHokoku.jochoComment : '',
        romuComment: this.form.gyomuHokoku.romuComment != null ? this.form.gyomuHokoku.romuComment : '',
      }
      params = new URLSearchParams(params);
      this.$axios.post('/gwr/wf/' + target, params)
          .then((response) => {
            this.isCommentDialogVisible = false;
            this.getData();
            if (response.status == '200') {
              notifySuccess(this, '処理完了', shori + 'しました。');
            } else {
              notifyWarning(this, '処理完了', shori + 'が完了しましたがメール送信に失敗しました。別途連絡をお願いします。');
            }
          })
          .catch((error) => {
            notifyError(this, error, 'データ登録エラー');
          });
      this.isCheckDialogVisible = false;
    },
    onCheck(target) {
      this.checkList = [];
      this.errorList = [];
      this.isConfirmDownload = false;
      this.isConfirmSendJocho = false;
      this.isConfirmSendRomu = false;
      this.isConfirmSendDairi = false;
      this.isOk = false;
      this.isWarning = false;
      this.isError = false;
      this.target = target;
      for (const oneday of this.form.gyomuHokoku.kimmuJissekiList) {
        let isEigyobi = (oneday.kyujitsu !== null && oneday.kyujitsu.eigyobiFlag)
        if (oneday.shigyoJikoku === null) {    // 出勤していない
          // 平日の始業時刻が入力されていなければWarning(全日有給休暇21、振休24、計画年休25、その他休暇30、欠勤28は除く)
          if (!(oneday.yobi === "土" || oneday.yobi === "日" || oneday.yobi === "祝")) {
            if (!(oneday.kimmuKubun == 21 || oneday.kimmuKubun == 24 || oneday.kimmuKubun == 25 || oneday.kimmuKubun == 30 || oneday.kimmuKubun == 28)) {
              this.checkList.push({ hiduke: oneday.kimmuBiDisplay, yobi: oneday.yobi, warn: "平日ですが未入力です。" });
            }
          }
          // 出勤はしていないが、リモートと通勤手当がどちらかが入力でWarning
          if (oneday.remoteFlag != "" || oneday.tsukinTeate != null || oneday.kotsuhi != null) {
            this.checkList.push({ hiduke: oneday.kimmuBiDisplay, yobi: oneday.yobi, warn: "出勤していないのに通勤手当、交通費、リモートが入力されています。" });
          }
        } else {  // 出勤している
          // 出勤はしている(始業時刻は入力されている)が、リモートと通勤手当がどちらも未入力でWarning
          // 定期の方(teikiHitsuyoFlag === true)は除外
          if (oneday.remoteFlag == "" && oneday.tsukinTeate == null && !(this.form.gyomuHokoku.shain.teikiHitsuyoFlag)) {
            this.checkList.push({ hiduke: oneday.kimmuBiDisplay, yobi: oneday.yobi, warn: "リモートと通勤手当がどちらも未入力です。" });
          }
          // 定期の方が、リモート入力でWarning
          if (oneday.remoteFlag != "" && this.form.gyomuHokoku.shain.teikiHitsuyoFlag) {
            this.checkList.push({ hiduke: oneday.kimmuBiDisplay, yobi: oneday.yobi, warn: "定期代支給設定ですが、リモートが選択されています。<br/>会社都合：このままで問題ございません。ご自身都合：リモートチェックを外してください。" });
          }
          // error!
          // 土日祝に出勤しているが勤務区分が振替出勤12休日出勤13でない
          if ((oneday.yobi === "土" || oneday.yobi === "日" || oneday.yobi === "祝")) {
            if (!(oneday.kimmuKubun == 12 || oneday.kimmuKubun == 13) && !isEigyobi) {
              this.errorList.push({ hiduke: oneday.kimmuBiDisplay, yobi: oneday.yobi, error: "土日祝の勤務区分は、休日出勤/振替出勤のいずれかにしてください。" });
            }
          }
          // error!
          // 平日出勤で振替出勤12休日出勤13が選ばれている
          if (!(oneday.yobi === "土" || oneday.yobi === "日" || oneday.yobi === "祝")) {
            if (oneday.kimmuKubun == 12 || oneday.kimmuKubun == 13) {
              this.errorList.push({ hiduke: oneday.kimmuBiDisplay, yobi: oneday.yobi, error: "平日の勤務区分は、休日出勤/振替出勤以外にしてください。" });
            }
          }
          // 昼食時間が規定昼食時間と異なる場合はﾜｰﾆﾝｸﾞ(勤務区分が午前半有給(22)、午後半有給(23)、時間単位有給(31)は除く)
          // 未設定(00:00)の場合は対象外
          this.onedayOhiruGohanTime = ""
          if (oneday.chushokuJikan == null) {
            this.onedayOhiruGohanTime = null;
          } else {
            if (oneday.chushokuJikan.length < 5) {
              this.onedayOhiruGohanTime = "0" + oneday.chushokuJikan;
            } else {
              this.onedayOhiruGohanTime = oneday.chushokuJikan;
            }
          }
          if ((this.onedayOhiruGohanTime != this.form.gyomuHokoku.shain.kijunChushokuJikan) && this.form.gyomuHokoku.shain.kijunChushokuJikan != "00:00") {
            if (!(oneday.kimmuKubun == 22 || oneday.kimmuKubun == 23 || oneday.kimmuKubun == 31) && !isEigyobi) {
              this.checkList.push({ hiduke: oneday.kimmuBiDisplay, yobi: oneday.yobi, warn: "昼食時間が社員設定の基準昼食時間(" + this.form.gyomuHokoku.shain.kijunChushokuJikan + ")と異なります。" });
            }
          }
          // 勤務区分が、午前半有給(22)、午後半有給(23)で、昼食時間が0(null)以外の場合はﾜｰﾆﾝｸﾞ
          if ((oneday.kimmuKubun == 22 || oneday.kimmuKubun == 23) && oneday.chushokuJikan != null) {
            this.checkList.push({ hiduke: oneday.kimmuBiDisplay, yobi: oneday.yobi, warn: "勤務区分が半日有給ですが、昼食時間が入力されています。" });
          }
          // error!
          // 勤務時間が6時間を超え、8時間以下の場合は少なくとも45分、8時間を超える場合は、少なくとも1時間の休憩が必要
          this.onedayKijyunJikanNaiTime = [0, 0];
          this.onedayTsujyoZangyoTime = [0, 0];
          this.onedayDoyoShukujitsuTime = [0, 0];
          this.onedayNichiyoTime = [0, 0];
          if (oneday.kijunJikanNaiKimmu != null) {
            this.onedayKijyunJikanNaiTime = oneday.kijunJikanNaiKimmu.split(":");
          }
          if (oneday.tsujoZangyo != null) {
            this.onedayTsujyoZangyoTime = oneday.tsujoZangyo.split(":");
          }
          if (oneday.doyoShukujitsuKimmu != null) {
            this.onedayDoyoShukujitsuTime = oneday.doyoShukujitsuKimmu.split(":");
          }
          if (oneday.nichiyoKimmu != null) {
            this.onedayNichiyoTime = oneday.nichiyoKimmu.split(":");
          }
          let kimmuHour = Number(this.onedayKijyunJikanNaiTime[0]) + Number(this.onedayTsujyoZangyoTime[0]) + Number(this.onedayDoyoShukujitsuTime[0]) + Number(this.onedayNichiyoTime[0]);
          let kimmuMin = Number(this.onedayKijyunJikanNaiTime[1]) + Number(this.onedayTsujyoZangyoTime[1]) + Number(this.onedayDoyoShukujitsuTime[1]) + Number(this.onedayNichiyoTime[1]);
          kimmuHour += Math.floor(kimmuMin / 60);
          kimmuMin = kimmuMin % 60;
          const totalKimmuTime = kimmuHour + (kimmuMin / 100);  // 勤務時間の合計

          this.onedayOhiruGohanTime = [0, 0];
          this.onedayKyukeiTime = [0, 0];
          if (oneday.chushokuJikan != null) {
            this.onedayOhiruGohanTime = oneday.chushokuJikan.split(":");
          }
          if (oneday.kyukeiJikan != null) {
            this.onedayKyukeiTime = oneday.kyukeiJikan.split(":");
          }
          let breakHour = Number(this.onedayOhiruGohanTime[0]) + Number(this.onedayKyukeiTime[0]);
          let breakMin = Number(this.onedayOhiruGohanTime[1]) + Number(this.onedayKyukeiTime[1]);
          breakHour += Math.floor(breakMin / 60);
          breakMin = breakMin % 60;
          const totalBreakTime = breakHour + (breakMin / 100);  // 休憩時間の合計

          if (6 < totalKimmuTime && totalKimmuTime <= 8) {
            if (totalBreakTime < 0.45) {
              this.errorList.push({ hiduke: oneday.kimmuBiDisplay, yobi: oneday.yobi, error: "勤務時間が6時間を超え、8時間以下の場合は45分以上の休憩が必要です。" });
            }
          } else if (8 < totalKimmuTime) {
            if (totalBreakTime < 1) {
              this.errorList.push({ hiduke: oneday.kimmuBiDisplay, yobi: oneday.yobi, error: "勤務時間が8時間を超える場合は1時間以上の休憩が必要です。" });
            }
          }

        }
        // error
        // 残業 or 休日出勤をしているが、残業理由(休出)が未入力
        if ((oneday.tsujoZangyo != null || oneday.doyoShukujitsuKimmu != null || oneday.nichiyoKimmu != null) && !isEigyobi) {
          if (oneday.zangyoRiyu == null) {
            this.errorList.push({ hiduke: oneday.kimmuBiDisplay, yobi: oneday.yobi, error: "残業理由(休出理由)を入力してください。" });
          }
        }
        // error
        // 残業をしていないのに、残業理由が入力されている
        if (oneday.tsujoZangyo == null && oneday.doyoShukujitsuKimmu == null && oneday.nichiyoKimmu == null) {
          if (oneday.zangyoRiyu != null) {
            this.errorList.push({ hiduke: oneday.kimmuBiDisplay, yobi: oneday.yobi, error: "残業理由(休出理由)の入力は不要です。" });
          }
        }
        // 残業発生時、休憩時間と社員設定の基準休憩時間が一致していないとwarning
        // 未設定(00:00)の場合は対象外
        if (!isEigyobi && oneday.tsujoZangyo != null && this.zeroPad(oneday.kyukeiJikan) != this.form.gyomuHokoku.shain.kijunKyukeiJikan && this.form.gyomuHokoku.shain.kijunKyukeiJikan != "00:00") {
          this.checkList.push({ hiduke: oneday.kimmuBiDisplay, yobi: oneday.yobi, warn: "休憩時間が社員設定の基準休憩時間(" + this.form.gyomuHokoku.shain.kijunKyukeiJikan + ")と異なります。" });
        }
        // error!
        // 勤務区分が、振休24、振出12、振休出15,16で、振替先の日付（勤務区分の右側のﾃｷｽﾄﾎﾞｯｸｽ）が未入力でerror
        if ((oneday.kimmuKubun == 24 || oneday.kimmuKubun == 12 || oneday.kimmuKubun == 15 || oneday.kimmuKubun == 16) && oneday.kimmuKubunHosoku == null) {
          this.errorList.push({ hiduke: oneday.kimmuBiDisplay, yobi: oneday.yobi, error: "勤務区分が振替出勤/振替休日の場合は、振替先の日付(勤務区分右のﾃｷｽﾄﾎﾞｯｸｽ)を入力してください。" });
        }
        // worning!
        // 日跨ぎ勤務の場合warning
        if (Date.parse(oneday.kimmuBi + " " + oneday.shigyoJikoku) > Date.parse(oneday.kimmuBi + " " + oneday.shugyoJikoku)) {
          this.checkList.push({ hiduke: oneday.kimmuBiDisplay, yobi: oneday.yobi, warn: "日跨ぎ勤務は、特殊な時間計算が必要なケースがあるので、労務にご確認ください。" });
        }
        // worning!
        // 勤務区分が出勤系で、WFが出ている場合はﾜｰﾆﾝｸﾞ
        if (["11", "12", "13", "14"].includes(oneday.kimmuKubun) && oneday.shigyoJikoku !== null
            && oneday.wfSubjectList.filter((Subject) => Subject.match(/取消/)).length == 0
            && oneday.wfSubjectList.filter((Subject) => Subject.match(/^(?!.*(在宅|時短|時差|外出)).*$/)).length != 0) {
          this.checkList.push({ hiduke: oneday.kimmuBiDisplay, yobi: oneday.yobi, warn: "ワークフローが提出されていますが、勤務区分が出勤系になっています。" });
        }
        // worning!
        if (["15", "16", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31"/*, "32"*/].includes(oneday.kimmuKubun)) {
          if (oneday.wfSubjectList.filter((Subject) => Subject.match(/^(?!.*(在宅|時短|時差|外出)).*$/)).length == 0) {
            // 勤務区分が休日系で、WFが出てない場合はﾜｰﾆﾝｸﾞ
            this.checkList.push({ hiduke: oneday.kimmuBiDisplay, yobi: oneday.yobi, warn: "ワークフローが必要な勤務区分ですが、ワークフローが提出されていません。" });
          } else {
            // 勤務区分が休日系で、WFの件名と勤務区分が食い違っている場合はﾜｰﾆﾝｸﾞ
            let wfKubun = oneday.kimmuKubunMei;
            if (wfKubun == "午前半有給") {
              wfKubun = "午前半有給|午前半有休";
            } else if (wfKubun == "午後半有給") {
              wfKubun = "午後半有給|午後半有休";
            } else if (wfKubun == "時間有給") {
              wfKubun = "時間単位有給|時間単位有休|時間有給|時間有休";
            } else if (wfKubun == "その他休暇") {
              wfKubun = "その他";
            } else if (wfKubun == "振休出勤(土祝)" || wfKubun == "振休出勤(日)") {
              wfKubun = "振休出勤";
            }
            if (oneday.wfSubjectList.filter((Subject) => Subject.match(new RegExp(wfKubun))).length == 0) {
              this.checkList.push({ hiduke: oneday.kimmuBiDisplay, yobi: oneday.yobi, warn: "勤務区分とワークフローの区分が一致していません。" });
            }
          }
        }
        // 社員総会warning!
        if (isEigyobi && (oneday.shigyoJikoku === null || oneday.kimmuKubun != 14)) {
          this.checkList.push({ hiduke: oneday.kimmuBiDisplay, yobi: oneday.yobi, warn: "社員総会開催日です。出席された場合は、勤務区分「社員総会」として登録してください。" });
        }
        if (!isEigyobi && oneday.kimmuKubun == 14) {
          this.checkList.push({ hiduke: oneday.kimmuBiDisplay, yobi: oneday.yobi, warn: "社員総会開催日ではありませんが、勤務区分が「社員総会」になっています。" });
        }
        if (isEigyobi && oneday.shigyoJikoku != null && oneday.shugyoJikoku != null && (this.zeroPad(oneday.shigyoJikoku) != oneday.kyujitsu.kijunShigyoJikoku || this.zeroPad(oneday.shugyoJikoku) != oneday.kyujitsu.kijunShugyoJikoku)) {
          this.checkList.push({ hiduke: oneday.kimmuBiDisplay, yobi: oneday.yobi, warn: "勤務時間が社員総会の規定勤務時間(" + oneday.kyujitsu.kijunShigyoJikoku + "～" + oneday.kyujitsu.kijunShugyoJikoku + ")と異なります。" });
        }
        if (isEigyobi && ((this.zeroPad(oneday.chushokuJikan) != oneday.kyujitsu.kijunChushokuJikan && oneday.kyujitsu.kijunChushokuJikan != "00:00") || (oneday.chushokuJikan != null && oneday.kyujitsu.kijunChushokuJikan == "00:00"))) {
          this.checkList.push({ hiduke: oneday.kimmuBiDisplay, yobi: oneday.yobi, warn: "昼食時間が社員総会の規定昼食時間(" + oneday.kyujitsu.kijunChushokuJikan + ")と異なります。" });
        }
        if (isEigyobi && ((this.zeroPad(oneday.kyukeiJikan) != oneday.kyujitsu.kijunKyukeiJikan && oneday.kyujitsu.kijunKyukeiJikan != "00:00") || (oneday.kyukeiJikan != null && oneday.kyujitsu.kijunKyukeiJikan == "00:00"))) {
          this.checkList.push({ hiduke: oneday.kimmuBiDisplay, yobi: oneday.yobi, warn: "休憩時間が社員総会の規定休憩時間(" + oneday.kyujitsu.kijunKyukeiJikan + ")と異なります。" });
        }
      }
      // Check結果に応じて表示切替
      if (this.checkList.length == 0 && this.errorList.length == 0) {
        this.isOk = true;
        this.form.gyomuHokoku.checkKekka = "OK";
        if (target == '') {
          this.isCheckDialogVisible = true;
        }
      } else {
        if ('download' == target) {
          this.isConfirmDownload = true;
        } else if ('sendJocho' == target) {
          this.isConfirmSendJocho = true;
        } else if ('sendRomu' == target) {
          this.isConfirmSendRomu = true;
        } else if ('sendDairi' == target) {
          this.isConfirmSendDairi = true;
        }
        if (this.checkList.length != 0) {
          this.isWarning = true;
          this.form.gyomuHokoku.checkKekka = "Warning";
        }
        if (this.errorList.length != 0) {
          this.isError = true;
          this.form.gyomuHokoku.checkKekka = "Error";
        }
        this.isCheckDialogVisible = true;
      }
      // Check結果をサーバーに登録
      let params = {
        shainId: this.form.gyomuHokoku.shainId,
        nengetsu: this.form.gyomuHokoku.nengetsu,
        checkKekka: this.form.gyomuHokoku.checkKekka
      }
      params = new URLSearchParams(params);
      this.$axios.post('/gwr/gyomu/saveCheckKekka', params)
        .then(() => {
        })
        .catch((error) => {
          notifyError(this, error, 'データ登録エラー');
        });
      // Excel出力・提出
      if ('download' == target && this.isOk) {
        this.onDownload();
      } else if (('sendJocho' == target || 'sendRomu' == target || 'sendDairi' == target) && this.isOk) {
        this.onConfirm(target);
      }
    },
    zeroPad(value) {
      let padded = null
      if (value != null) {
        if (value.length < 5) {
          padded = "0" + value;
        } else {
          padded = value;
        }
      }
      return padded;
    },
    closeCommentDialog() {
      this.isCommentDialogVisible = false;
    },
    closeCheckDialog() {
      this.isCheckDialogVisible = false;
    },
    handleExceed(files, fileList) {
      this.$message.warning(`The limit is 5, you selected ${files.length} files this time, add up to ${files.length + fileList.length} totally`);
    },
    handleSuccess() {
      notifySuccess(this, '週報取込完了', '勤務実績を登録しました。');
      this.getData();
      this.fileList.splice(0, 1);
    },
    handleError() {
      this.$message.error(`週報取込失敗`);
    },
    parseNum(n) {
      if (n != null) {
        var d= n.split(":");
        switch( d.length ){
        case 1: return d[0]*1.0;
        case 2: return d[1]*1.0+d[0]*60;
        case 3: return d[2]*1.0+d[1]*60+d[0]*3600;
        case 4: return d[3]*1.0+d[2]*60+d[1]*3600+d[0]*86400;
            }
      }
      return Number.NaN;
    },
  },
}
</script>

<style scoped>
#formArea {
  width: 1360px;
  margin-left: auto;
  margin-right: auto;
  line-height: 35px;
}
.gyomuHokokuTableSize {
  width: 1490px;
}
.gyomuHokokuTableSizeRomu {
  width: 1880px;
}
#gyomuHokokuTable {
  margin-left: auto;
  margin-right: auto;
  margin-top: 0px;
  margin-bottom: 20px;
  font-size: 14px;
  border-color: lightgray;
}
#gyomuHokokuTable >>> th {
  padding: 0px 0px;
  border-color: lightgray;
  color: dimgray;
  font-weight: bold;
}
#gyomuHokokuTable >>> th div {
  padding: 0px 0px;
  text-align: center;
}
#gyomuHokokuTable >>> td {
  padding: 0px 0px;
  border-color: lightgray;
}
#gyomuHokokuTable >>> td div {
  padding: 0px 0px;
  text-align: center;
}
#gyomuHokokuTable >>> .biko div {
  padding: 0px 1px;
  text-align: left;
  white-space: pre-wrap;
}
#gyomuHokokuTable >>> .el-table__footer td div {
  font-weight: bold;
}
#gyomuHokokuTable >>> .el-button--mini {
  padding: 4px 10px;
}
#gyomuHokokuTable >>> .sunday-row {
  background: mistyrose;
}

#gyomuHokokuTable >>> .saturday-row {
  background: powderblue;
}
#leftButton {
  display: inline-block;
  width: 380px;
  margin-bottom: 10px;
}
#centerButton {
  display: inline-block;
  width: 380px;
  margin-bottom: 10px;
}
#rightButton {
  display: inline-block;
  width: 440px;
  margin-bottom: 10px;
}
#romuCheck {
  top: 3px;
  left: 20px;
  line-height: 22px;
  text-align: right;
  position: fixed;
  font-family: 'Avenir', Helvetica, Arial, sans-serif, Osaka;
  font-size: 14px;
  color: #606266;
}
#teiki {
  top: 3px;
  right: 420px;
  line-height: 22px;
  position: fixed;
  font-family: 'Avenir', Helvetica, Arial, sans-serif, Osaka;
  font-size: 14px;
  color: #606266;
}
#keiroTable {
  border-collapse:  collapse;
  max-height: 120px;
  min-height: 40px;
  width: 400px;
  top: 3px;
  right: 20px;
  position: fixed;
}
#keiroTable td {
  border-style: solid;
  border-width: 1px;
  text-align: left;
  padding: 2px 3px;
  height: 16px;
  line-height: 15px;
  font-family: 'Avenir', Helvetica, Arial, sans-serif, Osaka;
  font-size: 14px;
  border-color: lightgray;
  background-color: #F5F7FA;
  color: #606266;
}
#yukyuTable {
  border-collapse:  collapse;
  width: 150px;
}
#yukyuTable td {
  border-style: solid;
  border-width: 1px;
  padding: 2px 3px;
  font-family: 'Avenir', Helvetica, Arial, sans-serif, Osaka;
  font-size: 14px;
  border-color: lightgray;
  background-color: #F5F7FA;
  color: #606266;
}
#shainShimeiLabel {
  font-size: 13px;
  margin-right: 1px;
}
#shainShimei {
  font-size: 15px;
  font-weight: bold;
  margin-right: 15px;
}
#commentDialog >>> .el-dialog__body {
  padding: 0px 10px 10px;
}
#commentDialog >>> .el-textarea {
  margin-bottom: 10px;
}
#checkDialog >>> .el-dialog__body {
  padding: 0px 10px 10px;
}
#errorListTable >>> th {
  padding: 3px 0px;
  color: rgb(248, 63, 63);
}
#errorListTable >>> td {
  padding: 3px 0px;
  color: rgb(248, 63, 63);
}
#checkListTable >>> th {
  padding: 3px 0px;
}
#checkListTable >>> td {
  padding: 3px 0px;
}
#teijiIkkatsu {
  padding: 7px 2px;
}
#syuhoTorikomi {
  padding: 7px 2px;
}
#yukyuZan {
  padding: 7px 2px;
  width: 50px;
}
.shusei {
  color: red;
}
.nengetsu {
  width: 140px;
}
.el-button {
  margin: 0px 1px !important;
}
.kimmuBi-tooltip {
  white-space: pre;
  font-size: 14px;
}
.zangyoRiyu-tooltip {
  white-space: pre;
  font-size: 14px;
}
h4 {
  font-weight: normal;
  margin: 0px;
}
a.el-tooltip {
  font-size: 14px;
  display: block;
}
a {
  font-size: 13px;
  display: block;
}
</style>
